/**
 * 1QA role model.
 *
 * Two layers:
 *  - PlatformRole: global role on the 1QA instance (stored on User).
 *  - OrgRole: role inside one Organization (stored on Membership).
 *
 * ADMIN          - administers the instance only: users, Project Admin invitations, organizations
 *                  overview, audit dashboard. Not part of any organization or project.
 * PROJECT_ADMIN  - (platform) may create one organization; becomes its PROJECT_ADMIN.
 * USER           - regular account; access comes only from org memberships / report shares.
 *
 * Inside an organization:
 * PROJECT_ADMIN  - creates projects, invites members/viewers, assigns members to projects,
 *                  connects AI models and plugins (org or project level), plus everything a MEMBER can.
 * MEMBER         - works on the projects they are assigned to: tests, test data, runs; shares reports.
 *                  Only the creator (or a PROJECT_ADMIN) changes a test or test data; others copy it.
 * VIEWER         - sees only reports shared with them and comments on them to the person who shared.
 */
export const PLATFORM_ROLES = ['ADMIN', 'PROJECT_ADMIN', 'USER'] as const;
export type PlatformRole = (typeof PLATFORM_ROLES)[number];

export const ORG_ROLES = ['PROJECT_ADMIN', 'MEMBER', 'VIEWER'] as const;
export type OrgRole = (typeof ORG_ROLES)[number];

export const ROLE_LABELS: Record<PlatformRole | OrgRole, string> = {
  ADMIN: 'Admin',
  PROJECT_ADMIN: 'Project Admin',
  USER: 'User',
  MEMBER: 'Project Member',
  VIEWER: 'View Only',
};
